module.exports = __webpack_public_path__ + "img/caopen.e05a4594.png";